module.exports = __webpack_public_path__ + "static/img/Upload_a_Medical_Record.42235ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Upload_a_Medical_Record.jpg
// module id = Ry9I
// module chunks = 0